<template>
  <div>

    <Login v-if="view === 'login'" @login-success="view = 'base'" />
    <Base v-else-if="view === 'base'" @missing-credentials="view = 'login'" />
    <!-- <Orders v-else-if="view === 'orders'" @back-to-home="view = 'home'" />
    <LiveData v-else-if="view === 'home'" @missing-credentials="view = 'login'" /> -->

  </div>
</template>

<script setup>
import { ref, watch} from 'vue';
import Login from './js/Pages/Login.vue';
import Base from './js/Pages/Base.vue';

const view = ref('login');

watch(view, (newView) => {
  if (newView === 'login') {
    console.log("Switched to Login view");
  } else if (newView === 'base') {
    console.log("Switched to Base view");
  }
});

</script>

<style>
  h1 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  h2 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  h3 {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
</style>
